import { setSpecificMessage, minSize } from "valibot";
setSpecificMessage(
  minSize,
  (issue) => `Taille invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);